import $iygad$intlcolorarAEmjs from "../intl/color/ar-AE.mjs";
import $iygad$intlcolorbgBGmjs from "../intl/color/bg-BG.mjs";
import $iygad$intlcolorcsCZmjs from "../intl/color/cs-CZ.mjs";
import $iygad$intlcolordaDKmjs from "../intl/color/da-DK.mjs";
import $iygad$intlcolordeDEmjs from "../intl/color/de-DE.mjs";
import $iygad$intlcolorelGRmjs from "../intl/color/el-GR.mjs";
import $iygad$intlcolorenUSmjs from "../intl/color/en-US.mjs";
import $iygad$intlcoloresESmjs from "../intl/color/es-ES.mjs";
import $iygad$intlcoloretEEmjs from "../intl/color/et-EE.mjs";
import $iygad$intlcolorfiFImjs from "../intl/color/fi-FI.mjs";
import $iygad$intlcolorfrFRmjs from "../intl/color/fr-FR.mjs";
import $iygad$intlcolorheILmjs from "../intl/color/he-IL.mjs";
import $iygad$intlcolorhrHRmjs from "../intl/color/hr-HR.mjs";
import $iygad$intlcolorhuHUmjs from "../intl/color/hu-HU.mjs";
import $iygad$intlcoloritITmjs from "../intl/color/it-IT.mjs";
import $iygad$intlcolorjaJPmjs from "../intl/color/ja-JP.mjs";
import $iygad$intlcolorkoKRmjs from "../intl/color/ko-KR.mjs";
import $iygad$intlcolorltLTmjs from "../intl/color/lt-LT.mjs";
import $iygad$intlcolorlvLVmjs from "../intl/color/lv-LV.mjs";
import $iygad$intlcolornbNOmjs from "../intl/color/nb-NO.mjs";
import $iygad$intlcolornlNLmjs from "../intl/color/nl-NL.mjs";
import $iygad$intlcolorplPLmjs from "../intl/color/pl-PL.mjs";
import $iygad$intlcolorptBRmjs from "../intl/color/pt-BR.mjs";
import $iygad$intlcolorptPTmjs from "../intl/color/pt-PT.mjs";
import $iygad$intlcolorroROmjs from "../intl/color/ro-RO.mjs";
import $iygad$intlcolorruRUmjs from "../intl/color/ru-RU.mjs";
import $iygad$intlcolorskSKmjs from "../intl/color/sk-SK.mjs";
import $iygad$intlcolorslSImjs from "../intl/color/sl-SI.mjs";
import $iygad$intlcolorsrSPmjs from "../intl/color/sr-SP.mjs";
import $iygad$intlcolorsvSEmjs from "../intl/color/sv-SE.mjs";
import $iygad$intlcolortrTRmjs from "../intl/color/tr-TR.mjs";
import $iygad$intlcolorukUAmjs from "../intl/color/uk-UA.mjs";
import $iygad$intlcolorzhCNmjs from "../intl/color/zh-CN.mjs";
import $iygad$intlcolorzhTWmjs from "../intl/color/zh-TW.mjs";

var $f27aae6ac296c109$exports = {};


































$f27aae6ac296c109$exports = {
    "ar-AE": $iygad$intlcolorarAEmjs,
    "bg-BG": $iygad$intlcolorbgBGmjs,
    "cs-CZ": $iygad$intlcolorcsCZmjs,
    "da-DK": $iygad$intlcolordaDKmjs,
    "de-DE": $iygad$intlcolordeDEmjs,
    "el-GR": $iygad$intlcolorelGRmjs,
    "en-US": $iygad$intlcolorenUSmjs,
    "es-ES": $iygad$intlcoloresESmjs,
    "et-EE": $iygad$intlcoloretEEmjs,
    "fi-FI": $iygad$intlcolorfiFImjs,
    "fr-FR": $iygad$intlcolorfrFRmjs,
    "he-IL": $iygad$intlcolorheILmjs,
    "hr-HR": $iygad$intlcolorhrHRmjs,
    "hu-HU": $iygad$intlcolorhuHUmjs,
    "it-IT": $iygad$intlcoloritITmjs,
    "ja-JP": $iygad$intlcolorjaJPmjs,
    "ko-KR": $iygad$intlcolorkoKRmjs,
    "lt-LT": $iygad$intlcolorltLTmjs,
    "lv-LV": $iygad$intlcolorlvLVmjs,
    "nb-NO": $iygad$intlcolornbNOmjs,
    "nl-NL": $iygad$intlcolornlNLmjs,
    "pl-PL": $iygad$intlcolorplPLmjs,
    "pt-BR": $iygad$intlcolorptBRmjs,
    "pt-PT": $iygad$intlcolorptPTmjs,
    "ro-RO": $iygad$intlcolorroROmjs,
    "ru-RU": $iygad$intlcolorruRUmjs,
    "sk-SK": $iygad$intlcolorskSKmjs,
    "sl-SI": $iygad$intlcolorslSImjs,
    "sr-SP": $iygad$intlcolorsrSPmjs,
    "sv-SE": $iygad$intlcolorsvSEmjs,
    "tr-TR": $iygad$intlcolortrTRmjs,
    "uk-UA": $iygad$intlcolorukUAmjs,
    "zh-CN": $iygad$intlcolorzhCNmjs,
    "zh-TW": $iygad$intlcolorzhTWmjs
};


export {$f27aae6ac296c109$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
